import React from 'react';
import {
  Button,
  Form,
  FormBody,
  FormFooter,
  Modal,
  ModalContent,
  ModalHeader,
  ModalSection,
  Title,
} from '@zen-common/components-base';
import { NamingAssetStore, SettingsStore, ZenJsUtils, FpUtils } from '@zen/common-app-parts';
import { Decimal } from 'decimal.js';
import { textUtils } from '@zen/common-utils';
import AssetFG from '../../components/form/result/AssetFG';
import CommandFG from '../../components/form/result/CommandFG';
import { VerifyAssetStore } from '../../stores/FixedPayoutStore';
import OraclesDropDownFG from '../../components/form/edit/OraclesDropDownFG/OraclesDropDownFG';
import _oracles from '../../utils/oracles';
import CopyableExpandableFormGroup from '../../components/form/result/CopyableExpandableFormGroup';

const oracles = _oracles.map((o) => ({ label: `${o.chain} ${o.address}`, value: o.address }));

export default function VerifyAssetResult({ hide }) {
  const { state: naming } = NamingAssetStore.useStore();
  const {
    actions,
    state: { asset1, oracle, result },
  } = VerifyAssetStore.useStore();

  const {
    state: {
      settings: { chain },
    },
  } = SettingsStore.useStore();
  const setOracle = () => {
    const address = ZenJsUtils.getContractAddress(chain, contractId);
    actions.setOracle(_oracles.find((o) => o.address === address) || null);
  };

  const { publicKey, contractId, expiry, price, start, ticker, asset } = result.assetInfo;

  const position = FpUtils.getPosition({
    assetId: asset1.value,
    contractId,
    expiry,
    price,
    start,
    ticker,
    asset,
    publicKey,
  }).position;

  return (
    <Modal>
      <ModalContent large>
        <ModalHeader>{<Title>The assets generated by the contract are:</Title>}</ModalHeader>
        <ModalSection>
          <Form>
            <FormBody>
              <>
                <CopyableExpandableFormGroup
                  label="Generated by Address"
                  value={ZenJsUtils.getContractAddressFromAsset(chain, asset1.value)}
                />

                <OraclesDropDownFG items={oracles} value={oracle} onChange={setOracle} />

                <CommandFG label="Position" value={position} />

                <AssetFG
                  label={FpUtils.getTitle({ asset: asset1.value, naming })}
                  value={asset1.value}
                  readOnly
                />

                <AssetFG
                  label={FpUtils.getTitle({ asset: asset, title: 'Collateral', naming })}
                  value={asset}
                  readOnly
                />

                <CommandFG label="Ticker" value={ticker} />

                <CommandFG label="Price" value={new Decimal(price).dividedBy(100).toString()} />

                <CommandFG
                  label={`${expiry !== start ? 'Start' : ''} Event Date`}
                  value={textUtils.getDateStringFromTimestamp(start)}
                />

                {expiry !== start && (
                  <CommandFG
                    label="End Event Date"
                    value={textUtils.getDateStringFromTimestamp(expiry)}
                  />
                )}
              </>
            </FormBody>
            <FormFooter>
              <Button type="submit" onClick={hide}>
                Close
              </Button>
            </FormFooter>
          </Form>
        </ModalSection>
      </ModalContent>
    </Modal>
  );
}
